export default __webpack_public_path__ + "static/media/naidi-3-1.a921b9a3.svg";